<template>
            <div class="fixed-bottom bg-white border-top d-flex justify-content-around py-2">
                <button
                    class="btn fw-bold d-flex flex-column align-items-center"
                    :class="getButtonClass('/container')"
                    @click="goTo('/container')"
                >
                    <i class="fas fa-list fs-4 mb-2"></i>
                    我的詢價
                </button>
                <button
                    class="btn fw-bold d-flex flex-column align-items-center"
                    :class="getButtonClass('/container?type=history')"
                    @click="goTo('/container', { type: 'history' })"
                >
                    <i class="fas fa-history fs-4 mb-2"></i>
                    歷史詢價
                </button>
                <button
                    class="btn fw-bold d-flex flex-column align-items-center"
                    :class="getButtonClass('/container/add')"
                    @click="goTo('/container/add')"
                >
                    <i class="fas fa-plus-circle fs-4 mb-2"></i>
                    新增詢價
                </button>
            </div>
        </template>

        <script>
        export default {
            methods: {
                goTo(path, query = {}) {
                    this.$router.push({ path, query });
                },
                getButtonClass(path) {
                    return this.$route.fullPath === path ? 'text-success' : 'text-secondary';
                }
            }
        };
        </script>
